import { ClassNamesConfig } from "react-select";

export const selectBaseClassNames = (
  disabled: boolean = false
): ClassNamesConfig => ({
  container: () => "pazia-select-container",
  control: () =>
    disabled
      ? "pazia-select-control pazia-select-control--disabled"
      : "pazia-select-control",
  option: ({ isFocused, isSelected }) =>
    [
      "pazia-select-option",
      isFocused && "pazia-select-option--focused",
      isSelected && "pazia-select-option--selected",
    ]
      .filter(Boolean)
      .join(" "),
  menuPortal: () => "pazia-select-menu-portal",
  menu: () => "pazia-select-menu",
  menuList: () => "pazia-select-menu-list",
  multiValue: () => "pazia-select-multi-value",
  multiValueLabel: () => "pazia-select-multi-value-label",
  multiValueRemove: () => "pazia-select-multi-value-remove",
  placeholder: () => "pazia-select-placeholder",
  singleValue: () => "pazia-select-single-value",
  input: () => "pazia-select-input",
});
